"use client";

import { FaireLogo } from "@faire/web/slate/logos/FaireLogo";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Link } from "@faire/web/ui/LinkAnchor";
import React, { forwardRef } from "react";
import styled from "styled-components";

import { home } from "@faire/retailer/paths";

import { MINIMAL_HEADER_HEIGHT, MINIMAL_HEADER_HEIGHT_MOBILE } from "./consts";
import { HeaderContainer } from "./styled";

interface IProps {
  inactive?: boolean;
}

export const HeaderMinimal = forwardRef<HTMLElement, IProps>(
  ({ inactive }, ref) => (
    <HeaderContainer $isMinimal ref={ref}>
      <LogoWrapper>
        {inactive ? (
          <FaireLogo />
        ) : (
          <Link to={home()}>
            <FaireLogo />
          </Link>
        )}
      </LogoWrapper>
    </HeaderContainer>
  )
);

const LogoWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${MINIMAL_HEADER_HEIGHT}px;

  ${responsiveMediaQueries.mobile} {
    height: ${MINIMAL_HEADER_HEIGHT_MOBILE}px;
  }
`;
